import { CdkCopyToClipboard } from '@angular/cdk/clipboard'
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core'

import { TagModule } from 'primeng/tag'

import { FlxIconModule } from '@flowx/angular-ui-toolkit'
import { UiFlowSessionState } from '@flowx/core-sdk'
import { uiFlowStatusTagTypeMap } from '@flowx/designer/modules/core/dictionary/common.types'

@Component({
  selector: 'flx-ui-flow-session-details-panel-header',
  imports: [FlxIconModule, CdkCopyToClipboard, TagModule],
  templateUrl: './ui-flow-session-details-panel-header.component.html',
  styleUrl: './ui-flow-session-details-panel-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiFlowSessionDetailsPanelHeaderComponent {
  name = input.required<string>()
  uuid = input.required<string>()
  state = input.required<UiFlowSessionState>()

  severity = computed(() => {
    const state = this.state()
    return uiFlowStatusTagTypeMap[state] || 'info'
  })

  copiedTextToClipboard = signal(false)

  onCopyToClipboardSuccess(): void {
    this.copiedTextToClipboard.set(true)
    setTimeout(() => this.copiedTextToClipboard.set(false), 2000)
  }
}
